import React from "react";

import SrrRowBase from "./SrrRowBase";

const ReportReturnSRR5ByDealer = ({ row, items, group }) => {
  const dealerArr = ["DealerName", "INN", "ent_id", "subject", "FO", "city"];
  const TO = ["TO1", "TO2", "TO3", "TO4", "TO5", "monthControl"];
  let sumServiceCount = 0;
  let sumSaleCount = 0;

  let renderItem = Object.keys(row)
    .map((key) => {
      if (TO.includes(key)) {
        let serviceCount = row[key]?.cars.length;
        let percent = 0;
        if (row[key]?.saleCount > 0 && serviceCount > 0) {
          percent = (serviceCount / row[key]?.saleCount) * 100;
        }
        sumServiceCount = Number(sumServiceCount) + Number(serviceCount);
        sumSaleCount = Number(sumSaleCount) + Number(row[key]?.saleCount);
        return [row[key]?.saleCount, serviceCount, percent.toFixed(2)];
      }
    })
    .filter((value) => value !== undefined);

  const renderSum = [];

  if (group["monthControl"]) {
    let sumPercents = 0;
    if (sumServiceCount > 0 && sumSaleCount > 0) {
      sumPercents = (sumServiceCount / sumSaleCount) * 100;
    }
    renderSum.push(sumSaleCount, sumServiceCount, sumPercents.toFixed(2));
  }

  return (
    <SrrRowBase
      leadingCells={dealerArr.map((el) => row[el])}
      cells={[...renderItem, ...(renderSum.length > 0 ? [renderSum] : [])]}
    />
  );
};

export default ReportReturnSRR5ByDealer;
